








































































































































































import {
  Component,
  Vue,
  Prop,
  Watch,
} from 'vue-property-decorator';
import { Action, Getter, Mutation } from 'vuex-class';
import { ApiV2Service } from '../../services/api.base.service';
import { getDeviceImage } from '@/classes/images';
import FileUpload from '@/components/FileUpload.vue';
import { Cropper } from 'vue-advanced-cropper';
import '../../classes/blob.image.convert';
import AdminDeviceTypeService from '../../services/admin.devicetype.service';
import GenericButton from '@/components/GenericButton.vue';
import SimService from '@/services/sim.service';

@Component({
  components: {
    GenericButton,
    FileUpload,
    Cropper,
  },
})
export default class AdminDeviceTypeDetails extends Vue {
  private menu: object[] = [
    { title: 'Device Type Details', path: ''},
    { title: 'Edit Mapping Function', path: 'organisation_settings'},
    { title: 'Edit Downlink Function', path: 'billing' },
    { title: 'Edit Data Schema', path: 'billing' },
    { title: 'Edit Configuration Profiles', path: 'billing' },
    { title: 'Edit Event Rules', path: '/rules' },
  ];

  @Prop({default: {}}) private deviceType: any;
  @Prop() private logo!: Blob | null;
  @Prop({default: false}) private isManufacturerDialogVisible!: boolean;
  @Prop({default: false}) private isChipManufacturerDialogVisible!: boolean;
  @Prop({default: false}) private isDeviceModelDialogVisible!: boolean;

  private manufacturers: any[] = [];
  private chipManufacturers: any[] = [];
  private networks: any[] = [];
  private deviceModels: any[] = [];
  private deviceCategories: string[] = ['Device', 'Sensor', 'Bridge'];
  private LANProtocol: string[] = ['Modbus', 'MBus'];
  private statuses: string[] = ['Draft', 'Complete', 'InLife', 'Certified', 'Deprecated', 'Deleted'];
  private dropDownOptions: any = {};
  private loraDeviceClasses: string[] = ['A', 'B', 'C'];
  private formFactors: any[] = [];

  @Getter private organisations: any;

  private logoData: any = {};
  private logoCopy: Blob | null = null;
  private croppedLogo: Blob | null = null;
  private saveImage: boolean = false;
  private showCropper: boolean = false;

  private async mounted() {
    const deviceLogo = this.deviceImage();
    this.logoCopy = this.logo;

    if (deviceLogo.length) {
      this.logoCopy = await ApiV2Service.getBlobExt(deviceLogo, {ignoreErrors: true, crossDomain: true});
    }

    this.logoData = {
      logo: this.logoCopy,
      croppedLogo: this.croppedLogo,
      saveImage: this.saveImage,
      showCropper: this.showCropper,
    };

    await Promise.all([
      this.addDeviceModels(),
      this.addManufacturers(),
      this.addChipManufacturers(),
      this.addNetworks(),
      this.getFormFactors(),
    ]);
  }

  @Watch('isDeviceModelDialogVisible')
  private async onDeviceModelDialogChange(isVisible: boolean) {
    if (!isVisible) {
      await this.addDeviceModels();
    }
  }

  @Watch('isChipManufacturerDialogVisible')
  private async onChipManufacturerDialogChange(isVisible: boolean) {
    if (!isVisible) {
      await this.addChipManufacturers();
    }
  }

  @Watch('isManufacturerDialogVisible')
  private async onManufacturerDialogChange(isVisible: boolean) {
    if (!isVisible) {
      await this.addManufacturers();
    }
  }

  private changeManufacturer(event: any) {
    Vue.delete(this.deviceType, 'device_model');
    Vue.set(this.deviceType, 'device_model', { manufacturer_id : Number(event.value)});
  }

  private setDeviceModel(event: any) {
    const model = this.deviceModels.find((dm: any) => dm.id === Number(event.value));
    this.deviceType.device_model_id = model.id;
    this.deviceType.device_model = model;
  }

  private setChipManufacturer(event: any) {
    this.deviceType.chip_manufacturer_id = Number(event.value);
  }

  private setStatus(event: any) {
    this.deviceType.status = event.value;
  }

  private setDeviceClass(event: any) {
    this.deviceType.device_class = event.value;
  }

  private setLoraVersion(event: any) {
    this.deviceType.lorawan_version = event.value;
  }

  private setLoraRegion(event: any) {
    this.deviceType.lorawan_region = event.value;
  }

  private setDeviceCategory(event: any) {
    Vue.set(this.deviceType, 'device_category', event.value);

    if (event.value === 'sensor') {
      this.setBearer({ value: 5 });
    }

    if (event.value !== 'bridge') {
      Vue.set(this.deviceType, 'require_local_node_addresses', false);
    }
  }

  private setLANProtocol(event: any) {
    Vue.set(this.deviceType, 'lan_protocol', event.value);
  }

  private setOrganisation(event: any) {
    this.deviceType.organisation_id = Number(event.value);
  }

  private async setBearer(event: any) {
    const network = this.networks.find((nw: any) => nw.id === Number(event.value));
    Vue.set(this.deviceType, 'bearer', network.name.toLowerCase().replace('-', ''));
  }

  private get dropDownManufacturers(): any[] {
    return this.manufacturers.map((manuf: Entity): DropDownOption => {
      return { active: manuf.id === this.deviceType.device_model.manufacturer_id, name: manuf.name, id: manuf.id};
    }).sort(byName);
  }

  private get dropDownDeviceModels(): any[] {
    return this.deviceModels.filter((dm: any) => {
      return dm.manufacturer_id === this.deviceType.device_model.manufacturer_id;
    }).map((dm: Entity): DropDownOption => {
      return { active: dm.id === this.deviceType.device_model_id, name: dm.name, id: dm.id };
    }).sort(byName);
  }

  private get dropDownChipManufacturers(): any[] {
    return this.chipManufacturers.map((cm: Entity): DropDownOption => {
      return { active: cm.id === this.deviceType.chip_manufacturer_id, name: cm.name, id: cm.id};
    }).sort(byName);
  }

  private get dropDownOrganisations(): any[] {
    return this.organisations.organisations.map((org: Entity): DropDownOption => {
      return { active: org.id === this.deviceType.organisation_id, name: org.name, id: org.id};
    }).sort(byName);
  }

  private get dropDownNetworks(): any[] {
    return this.networks.map((nw: Entity): DropDownOption => {
      return { active: nw.name.toLowerCase().replace('-', '') === this.deviceType.bearer, name: nw.name, id: nw.id };
    }).sort(byName);
  }

  private get dropDownDeviceCategories(): any[] {
    return this.deviceCategories.map((cat: string): DropDownOption => {
      return { active: cat.toLowerCase() === this.deviceType.device_category, name: cat, id: cat.toLowerCase() };
    });
  }

  private get dropDownStatus(): any[] {
    return this.statuses.map((status: string): DropDownOption => {
      return { active: status.toLowerCase() === this.deviceType.status, name: status, id: status.toLowerCase() };
    });
  }

  private get dropDownDeviceClasses(): any[] {
    return this.loraDeviceClasses.map((deviceClass: string): DropDownOption => {
      return { active: deviceClass.toUpperCase() === this.deviceType.device_class, name: deviceClass, id: deviceClass.toUpperCase() };
    });
  }

  private get dropDownLoraVersions(): any[] {
    return ['1.0.0', '1.0.1', '1.0.2', '1.0.3', '1.0.4', '1.1'].map((v) => ({
      active: v === this.deviceType.lorawan_version, name: v, id: v,
    }));
  }

  private get dropDownLoraRegion(): any[] {
    return ['EU868', 'US915', 'CN779', 'EU433', 'AU915', 'CN470', 'AS923', 'KR920', 'IN865', 'RU864'].map((v) => ({
      active: v === this.deviceType.lorawan_region, name: v, id: v,
    }));
  }

  private get dropDownLANProtocols(): any[] {
    return this.LANProtocol.map((lanProtocol: string): DropDownOption => {
      return { active: lanProtocol === this.deviceType.lan_protocol, name: lanProtocol, id: lanProtocol };
    });
  }

  private async addNewManufacturer() {
    this.$emit('showManufacturerDialog');
  }

  private async addNewModel() {
    this.$emit('showDeviceModelDialog');
  }

  private async addNewChipManufacturer() {
    this.$emit('showChipManufacturerDialog');
  }

  private async getFormFactors() {
    const formFactors = await SimService.getFormFactors();
    Vue.set(this, 'formFactors', formFactors);
  }

  private deviceImage() {
    if (this.deviceType && this.deviceType.slug) {
      return getDeviceImage(this.deviceType);
    } else {
      return '';
    }
  }

  private get getLogoSrc(): string {
    let src = '';
    if (this.logoCopy) {
      src = URL.createObjectURL(this.logoCopy);
    }
    return src;
  }

  private removeLogo(): void {
    this.saveImage = true;
    this.logoCopy = null;

    Vue.set(this.logoData, 'logo', this.logoCopy);
    Vue.set(this.logoData, 'saveImage', this.saveImage);
  }

  private async addLogo(file: any): Promise<void> {
    this.saveImage = true;
    this.logoCopy = file.files[0];

    Vue.set(this.logoData, 'logo', this.logoCopy);
    Vue.set(this.logoData, 'saveImage', this.saveImage);
  }

  private async onCropperChange(event: any) {
    const canvas: HTMLCanvasElement = event.canvas;
    await (new Promise((res, reject) =>
      canvas.toBlob((blob: Blob | null) => {
        this.croppedLogo = blob;
      }, 'image/png'),
    ));

    Vue.set(this.logoData, 'croppedLogo', this.croppedLogo);

  }

  private getImageSize(event: any) {
    this.showCropper = event.target.height !== event.target.width;
    Vue.set(this.logoData, 'showCropper', this.showCropper);

    if (!this.showCropper) {
      event.target.style.visibility = 'visible';
    }
  }

  private async addDeviceModels() {
    this.deviceModels = await AdminDeviceTypeService.getDeviceModels();
  }

  private async addChipManufacturers() {
    this.chipManufacturers = await AdminDeviceTypeService.getChipManufacturers();
  }

  private async addManufacturers() {
    this.manufacturers = await AdminDeviceTypeService.getManufacturers();
  }

  private async addNetworks() {
    this.networks = await AdminDeviceTypeService.getNetworks();
  }
}

const byName = (a: DropDownOption, b: DropDownOption) => {
  if (a.name.toLowerCase() < b.name.toLowerCase()) {
    return -1;
  } else if (a.name.toLowerCase() > b.name.toLowerCase()) {
    return 1;
  } else {
    return 0;
  }
};

interface DropDownOption {
  active: boolean;
  name: string;
  id: number | string;
}

interface Entity {
  name: string;
  id: number;
}
